import { ModalInfoType } from './modal-info-type.const';

export const MODAL_INFO_ROUTES_MAP: Map<ModalInfoType, string[]> = new Map<ModalInfoType, string[]>([
    [ModalInfoType.SuccessRefinancing, ['success-info']],
    [ModalInfoType.FailedCardCheck, ['error-info']],
    [ModalInfoType.FailedRefinancing, ['error-info']],
    [ModalInfoType.WorkSalaryChanged, ['change-profile']],
]);
